import template from './bFilterTree.html';
import moment from 'moment';

export function bFilterTreeDirective() {
  'ngInject';
  return {
    restrict: 'E',
    template: template,
    controller: bFilterTreeController,
    controllerAs: 'bFilterTree',
    bindToController: true,
    scope: {
      groups: '=',
      selectedClientsEx: '=',
      onFiltersChange: '&',
      selectedItems: '@'
    }
  };
}

class bFilterTreeController {
  constructor($scope, $translate) {
    'ngInject';

    this.$scope = $scope;
    this.$translate = $translate;
    this.all = false;
    this.openMap = {};
    this.groupSums = {};
    this.selectedClients = {};
    this.selectedGroups = {};
    this.displayedItems = [];
    this.selectAllLabel = `${this.$translate.instant('VIEW360.TOGGLE_ALL')} ${this.$translate.instant('VIEW360.CLIENT_GROUPS')}`;
    this.$scope.$watch(() => this.groups, () => {
      this.search = '';
      this.filterData();
      this.preSelect();
    });
    this.$scope.$watch(() => this.selectedItems, () => {
      setTimeout(() => this.sortGroups(), 10); //sorry
    });
  }

  calculateSelected(group) {
    this.groupSums[group.id] = 0;
    group.clients.forEach(client => {
      this.groupSums[group.id] += this.selectedClients[client.id] ? client.value : 0;
    });
    return this.groupSums[group.id];
  }

  filterData() {
    if (!this.groups) {
      this.displayedItems = [];
      return;
    }

    if (!this.search || !this.search.trim()) {
      this.displayedItems = angular.copy(this.groups);
      this.sortGroups();
      return;
    }
    const lowerSearch = this.search.trim().toLowerCase();
    let toDisplay = [];
    this.groups.forEach(g => {
      const group = angular.copy(g);
      let added = false;
      if (group.name.toLowerCase().indexOf(lowerSearch) > -1) {
        toDisplay.push(group);
        added = true;
      }

      if (added) {
        return;
      }

      group.clients.forEach(client => {
        if (!added && client.name.toLowerCase().indexOf(lowerSearch) > -1) {
          group.clients = group.clients.filter(client =>{
            return client.name.toLowerCase().indexOf(lowerSearch) > -1;
          });
          toDisplay.push(group);
          added = true;
          this.openMap[group.id] = true;
        }
      });
    });
    this.displayedItems = toDisplay;
    this.sortGroups();
  }

  experimentalSort(){
    var self = this;

    this.displayedItems.forEach(group => {
      this.calculateSelected(group);
    });

    this.displayedItems = this.displayedItems.sort((a, b) => {
      return self.selectedGroups[b.id] - self.selectedGroups[a.id]
        || (self.selectedGroups[b.id] === null) - (self.selectedGroups[a.id] === null);
    });

    this.displayedItems = this.displayedItems.sort((a, b) => {
      if(self.selectedGroups[a.id] === true || self.selectedGroups[b.id] === true || self.groupSums[a.id] > 0 || self.groupSums[b.id] > 0
        || self.selectedGroups[b.id] === null || self.selectedGroups[a.id] === null){
        if (self.groupSums[a.id] < self.groupSums[b.id]){
          return 1;
        }
        if (self.groupSums[a.id] > self.groupSums[b.id]){
          return -1;
        }
        return 0;
      } else {
        if ( a.name < b.name ){
          return -1;
        }
        if (  a.name >  b.name ){
          return 1;
        }
        return 0;
      }
    });

    //set No client group first
    this.displayedItems = this.displayedItems.sort(function(x,y){
      return x.name === "No client group" ? -1 : y.name === "No client group" ? 1 : 0; });

    this.displayedItems.forEach( group => {
      group.clients = group.clients.sort( (a,b) => {
        if(self.selectedClients[a.id] === true || self.selectedClients[b.id] === true){
          return self.selectedClients[b.id] - self.selectedClients[a.id]
            || b.value - a.value;
        }
        else {
          if ( a.name < b.name ){
            return -1;
          }
          if (  a.name >  b.name ){
            return 1;
          }
          return 0;
        }
      });
    });
  }

  sortGroups() {
    this.experimentalSort();
  }

  onClientSelectionChange(client, group) {
    const selectedCli = group.clients.filter(c => {
      return this.selectedClients[c.id];
    });

    this.selectedGroups[group.id] = selectedCli.length === group.clients.length;
    if (this.selectedGroups) {
      this.all = Object.keys(this.selectedGroups).filter(key => this.selectedGroups[key]).length === this.groups.length;
    }
    if (selectedCli.length !== group.clients.length) {
      this.selectedGroups[group.id] = selectedCli.length < 1 ? false : null;
    }

    const selectedClients = this.selectedClients;
    this.onFiltersChange({selectedClients});
  }

  onGroupSelectionChange(group) {
    const val = this.selectedGroups[group.id];
    group.clients.forEach(client => {
      this.selectedClients[client.id] = val;
    });

    if (this.selectedGroups) {
      this.all = Object.keys(this.selectedGroups).filter(key => this.selectedGroups[key]).length === this.groups.length;
    }

    const selectedClients = this.selectedClients;
    this.onFiltersChange({selectedClients});
  }

  preSelect() {
    if (!this.selectedClientsEx || !this.groups || !this.groups.length) {
      return;
    }

    this.selectedClients = {};
    this.selectedGroups = {};
    // below code duplicates a lot of onClientSelectionChange to avoid costly onFiltersChange calls
    this.groups.forEach(group => {
      let selectedClientsCount = 0;
      group.clients.forEach(client => {
        this.selectedClients[client.id] = !!this.selectedClientsEx[client.id];
        selectedClientsCount = selectedClientsCount + !!this.selectedClientsEx[client.id];
      });
      this.selectedGroups[group.id] = selectedClientsCount === group.clients.length;
      if (selectedClientsCount !== group.clients.length) {
        this.selectedGroups[group.id] = selectedClientsCount < 1 ? false : null;
      }
    });

    if (this.selectedGroups) {
      this.all = Object.keys(this.selectedGroups).filter(key => this.selectedGroups[key]).length === this.groups.length;
    }
  }

  toggleAll() {
    if (!this.groups) {
      return;
    }
    this.all = !this.all;

    this.groups.forEach(group => {
      this.selectedGroups[group.id] = this.all;
      group.clients.forEach(client => {
        this.selectedClients[client.id] = this.all;
      });
    });

    const selectedClients = this.selectedClients;
    this.onFiltersChange({selectedClients});
  }

  value(value) {
    const duration = moment.duration(value);
    return Math.round(duration.asHours());
  }
}
